import React from 'react';
import { Menu } from '@ui/menus/Menu';
import { Icon } from '@ui/Icon';
import { ProjectLabelsSubmenu } from '@features/projects/labels/ProjectLabels';

type ProjectMenuActions = {
  edit: () => void;
  duplicate: () => void;
  lock: () => void;
  unlock: () => void;
  archive: () => void;
  unarchive: () => void;
  template: () => void;
  exportSpreadsheet: () => void;
  exportBoverketXml?: () => void;
  updateProducts?: () => void;
};

type ProjectMenuContentProps = {
  projectId: string;
  locked: boolean;
  archived: boolean;
  isOwner: boolean;
  actions: ProjectMenuActions;
};

export const ProjectMenuContent: React.FC<ProjectMenuContentProps> = ({
  projectId,
  locked,
  archived,
  isOwner,
  actions,
}) => {
  const canUpdateProducts =
    !!actions.updateProducts && isOwner && !locked && !archived;

  return (
    <>
      <Menu.Item
        icon={<Icon category="mui" icon="Edit" />}
        disabled={
          !isOwner && locked
            ? 'Only the project owner can edit a locked project'
            : false
        }
        onClick={actions.edit}
      >
        Edit
      </Menu.Item>

      <ProjectLabelsSubmenu
        projectId={projectId}
        readonly={isOwner ? archived && !locked : locked || archived}
      />
      <Menu.Item
        icon={<Icon category="mui" icon="FileCopy" />}
        onClick={actions.duplicate}
      >
        Duplicate
      </Menu.Item>

      {!archived && (
        <Menu.Item
          icon={<Icon category="mui" icon={locked ? 'LockOpen' : 'Lock'} />}
          disabled={
            !isOwner &&
            `Only the project owner can ${locked ? 'unlock' : 'lock'} a project`
          }
          onClick={locked ? actions.unlock : actions.lock}
        >
          {locked ? 'Unlock' : 'Lock'}
        </Menu.Item>
      )}

      <Menu.Item
        icon={<Icon category="mui" icon={archived ? 'Unarchive' : 'Archive'} />}
        disabled={!isOwner && 'Only the project owner can archive project'}
        onClick={archived ? actions.unarchive : actions.archive}
      >
        {archived ? 'Unarchive' : 'Archive'}
      </Menu.Item>

      <Menu.Item
        icon={<Icon category="mui" icon="ListAlt" />}
        onClick={actions.template}
      >
        Save as template
      </Menu.Item>

      <Menu.Item
        icon={<Icon category="mui" icon="BorderAll" />}
        onClick={actions.exportSpreadsheet}
      >
        Export spreadsheet
      </Menu.Item>

      {actions.exportBoverketXml && (
        <Menu.Item
          icon={<Icon category="mui" icon="GetApp" />}
          onClick={actions.exportBoverketXml}
        >
          Export Boverket declaration XML
        </Menu.Item>
      )}

      {canUpdateProducts && (
        <Menu.Item
          icon={<Icon category="mui" icon="Refresh" />}
          onClick={actions.updateProducts}
        >
          Update products
        </Menu.Item>
      )}
    </>
  );
};
